import React, { Component } from "react";
import "../App.css";
import { Button, Form, Spinner } from "react-bootstrap";
// import back from '../assets/back.png'
import mail from "../assets/mail.png";
import { Link, Redirect } from "react-router-dom";
import code from "../assets/code.svg";

class ValidationCode extends Component {
  constructor(props) {
    super(props);

    this.state = {
      codeErrorText: "",
      time: {},
      seconds: 0,
      codeValue: "",
      buttonText: true,
      buttonSpinner: false,
      buttonDisabled: false,
      showResend: false,
      actionError: "",
    };

    this.startTimer = this.startTimer.bind(this);
    this.countDown = this.countDown.bind(this);
    this.codeHandleChange = this.codeHandleChange.bind(this);
    this.codeInput = React.createRef();
  }

  confirmClick = () => {
    this.setState({ actionError: "" });
    let code = document.getElementById("code");

    if (this.state.codeValue === "") {
      code.setAttribute("style", "border-color: var(--red1) !important");
      this.setState({ codeErrorText: "لطفاً کد ارسال شده را وارد کنید" });
      return;
    } else {
      code.setAttribute("style", "border-color: #cfcfcf !important");
      this.setState({ codeErrorText: "" });
    }

    if (this.state.codeValue.length === 5) {
      code.setAttribute("style", "border-color: #cfcfcf !important");
      this.setState({ codeErrorText: "" });
    } else {
      code.setAttribute("style", "border-color: var(--red1) !important");
      this.setState({ codeErrorText: "کد وارد شده نامعتبر است" });
      return;
    }

    this.setState({
      buttonText: false,
      buttonSpinner: true,
      buttonDisabled: true,
    });

    let data = {
      mobile: sessionStorage.getItem("mobile"),
      code: this.state.codeValue,
    };

    let apitype = "";
    if (sessionStorage.getItem("userStatus") === "signup") {
      apitype = "codeAuthorize";
    } else {
      apitype = "codeForgetAuthorize";
    }

    fetch("/api/" + apitype, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.status === 200) {
          sessionStorage.setItem("token", result.Token);
          this.props.onValidatedCode();
        } else if (result.status === 401) {
          code.setAttribute("style", "border-color: var(--red1) !important");
          this.setState({ codeErrorText: "کد وارد شده نامعتبر است" });
          this.setState({
            buttonText: true,
            buttonSpinner: false,
            buttonDisabled: false,
          });
        } else {
          this.setState({
            buttonText: true,
            buttonSpinner: false,
            buttonDisabled: false,
            actionError: "ارتباط با سرور برقرار نشد",
          });
        }
      });
  };

  secondsToTime(secs) {
    let hours = Math.floor(secs / (60 * 60));

    let divisor_for_minutes = secs % (60 * 60);
    let minutes = Math.floor(divisor_for_minutes / 60);

    let divisor_for_seconds = divisor_for_minutes % 60;
    let seconds = Math.ceil(divisor_for_seconds);

    hours = hours + "";
    minutes = minutes + "";
    seconds = seconds + "";

    let obj = {
      h: hours.padStart(2, "0"),
      m: minutes.padStart(2, "0"),
      s: seconds.padStart(2, "0"),
    };
    return obj;
  }

  componentDidMount() {
    if (
      sessionStorage.getItem("mobile") !== null &&
      sessionStorage.getItem("mobile") !== ""
    ) {
      this.codeInput.current.focus();
      this.startTimer();
    }
  }

  startTimer() {
    let totalsecend = 180;
    this.setState({
      seconds: totalsecend,
      time: this.secondsToTime(totalsecend),
    });
    this.timer = setInterval(this.countDown, 1000);
    this.setState({ showResend: false });
  }

  countDown() {
    // Remove one second, set state so a re-render happens.
    let seconds = this.state.seconds - 1;
    this.setState({
      time: this.secondsToTime(seconds),
      seconds: seconds,
    });

    // Check if we're at zero.
    if (seconds === 0) {
      this.setState({ showResend: true });
      clearInterval(this.timer);
    }
  }

  codeHandleChange(event) {
    let telephone = event.target.value;
    if (telephone !== "0" && telephone !== "") {
      if (!Number(telephone)) {
        return;
      }
    }
    this.setState({ codeValue: event.target.value });
  }

  resendCode() {
    this.setState({ actionError: "" });
    let data = {
      mobile: sessionStorage.getItem("mobile"),
    };
    this.setState({ buttonDisabled: true });
    let apitype = "";
    if (sessionStorage.getItem("userStatus") === "signup") {
      apitype = "checkUser";
    } else {
      apitype = "forgetPassword";
    }

    fetch("/api/" + apitype, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.status === 200 || result.status === 404) {
          this.startTimer();
          // alert(result.code);
          this.setState({ buttonDisabled: false });
        } else {
          this.setState({
            buttonText: true,
            buttonSpinner: false,
            buttonDisabled: false,
            actionError: "ارتباط با سرور برقرار نشد",
          });
        }
      });
  }

  handleKeyPress(target) {
    if (target.charCode === 13) {
      this.confirmClick();
    }
  }

  backPage() {
    this.props.onValidatedCodeBack();
  }

  render() {
    if (
      sessionStorage.getItem("mobile") !== null &&
      sessionStorage.getItem("mobile") !== ""
    ) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            flexDirection: "column",
            height: "100%",
          }}
        >
          <div className="backButtonContainer" />
          <div style={{ minWidth: "260px", maxWidth: "350px", width: "80%" }}>
            <div className="mobile">
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  fontSize: "12px",
                  color: "var(--textcolor1)",
                }}
              >
                <label
                  style={{ fontSize: "12px", color: "var(--textcolor1)" }}
                  htmlFor="code"
                >
                  شماره تلفن همراه:&nbsp;&nbsp;
                  {sessionStorage.getItem("mobile")}
                </label>
                <div>
                  {this.state.time.s} : {this.state.time.m}
                </div>
              </div>
              <div className="InputWithIcon">
                <div className="inputImageDiv">
                  <img src={code} className="inputImage" alt="mobile" />
                </div>
                <Form.Control
                  maxLength="5"
                  className="inputStyle"
                  placeholder="کد ارسال شده را وارد کنید"
                  type="text"
                  name="code"
                  id="code"
                  onChange={this.codeHandleChange}
                  value={this.state.codeValue}
                  disabled={this.state.buttonDisabled}
                  onKeyPress={this.handleKeyPress.bind(this)}
                  ref={this.codeInput}
                />
                <div className="inputImageDiv" />
              </div>

              <div className="errorMessage">{this.state.codeErrorText}</div>
            </div>
            <div className="createAccount">
              <Button
                id="btnLogin"
                style={{
                  width: "40%",
                  alignSelf: "flex-end",
                  float: "right",
                  fontSize: "14px",
                  height: "34px",
                }}
                disabled={this.state.buttonDisabled}
                onClick={this.confirmClick}
              >
                {this.state.buttonSpinner && (
                  <Spinner
                    style={{ color: "white", height: "20px", width: "20px" }}
                    animation="border"
                  />
                )}
                {this.state.buttonText && <div>تایید</div>}
              </Button>
              {this.state.showResend && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                  }}
                >
                  <img
                    style={{
                      height: "15px",
                      marginLeft: "10px",
                      color: "var(--green)",
                    }}
                    src={mail}
                    alt="resend"
                  />
                  <Link
                    onClick={
                      this.state.buttonDisabled
                        ? (event) => event.preventDefault()
                        : this.resendCode.bind(this)
                    }
                    style={{
                      marginTop: "4px",
                      padding: "0px",
                      fontSize: "12px",
                    }}
                  >
                    ارسال مجدد کد
                  </Link>
                </div>
              )}
            </div>

            {this.state.actionError !== "" && (
              <div className="errorMessageContainer">
                <div>{this.state.actionError}</div>
              </div>
            )}
          </div>
          <div className="backButtonContainer">
            <div className="backButton" onClick={this.backPage.bind(this)}>
              <div>بازگشت</div>
            </div>
          </div>
        </div>
      );
    } else {
      return <Redirect to="/Login" />;
    }
  }
}

export default ValidationCode;
